// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.styles_successIcon__YjyOw {
  display: flex;
  justify-content: center;
}

.styles_successDetails__uotxc {
  text-align: left;
  width: 100%;
}
.styles_successDetails__uotxc h3 {
  font: var(--typography-label);
  color: var(--color-black);
  margin-bottom: 16px;
}
.styles_successDetails__uotxc ul {
  list-style: none;
}
.styles_successDetails__uotxc li {
  padding: 8px 0 8px 28px;
  position: relative;
  color: var(--color-black);
  font: var(--typography-body-m-regular);
}
.styles_successDetails__uotxc li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #10b981;
  font-weight: bold;
  font-size: 16px;
}

.styles_welcomeTitle__WN7Mt {
  font: var(--typography-h2);
  text-align: center;
}

.styles_authPrompt__NTCI5 {
  text-align: center;
  color: var(--color-text-secondary);
  font: var(--typography-body-m-regular);
  max-width: 400px;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/screens/waitlist-success/styles.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;AACF;AACE;EACE,6BAAA;EACA,yBAAA;EACA,mBAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sCAAA;AADJ;AAGI;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AADN;;AAMA;EACE,0BAAA;EACA,kBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,kCAAA;EACA,sCAAA;EACA,gBAAA;EACA,cAAA;AAHF","sourcesContent":["@import \"mixins\";\n.successIcon {\n  display: flex;\n  justify-content: center;\n}\n\n.successDetails {\n  text-align: left;\n  width: 100%;\n\n  h3 {\n    font: var(--typography-label);\n    color: var(--color-black);\n    margin-bottom: 16px;\n  }\n\n  ul {\n    list-style: none;\n  }\n\n  li {\n    padding: 8px 0 8px 28px;\n    position: relative;\n    color: var(--color-black);\n    font: var(--typography-body-m-regular);\n\n    &::before {\n      content: \"✓\";\n      position: absolute;\n      left: 0;\n      color: #10b981;\n      font-weight: bold;\n      font-size: 16px;\n    }\n  }\n}\n\n.welcomeTitle {\n  font: var(--typography-h2);\n  text-align: center;\n}\n\n.authPrompt {\n  text-align: center;\n  color: var(--color-text-secondary);\n  font: var(--typography-body-m-regular);\n  max-width: 400px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"successIcon": `styles_successIcon__YjyOw`,
	"successDetails": `styles_successDetails__uotxc`,
	"welcomeTitle": `styles_welcomeTitle__WN7Mt`,
	"authPrompt": `styles_authPrompt__NTCI5`
};
export default ___CSS_LOADER_EXPORT___;
